{
  "title": "Gravity Fissure",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "6th-level evocation (dunamancy:graviturgy)",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self (100-foot line)",
  "components": "V, S, M (a fistful of iron filings)",
  "duration": "Instantaneous",
  "description": [
    "You manifest a ravine of gravitational energy in a line originating from you that is 100 feet long and 5 feet wide. Each creature in that line must make a Constitution saving throw, taking 8d8 force damage on a failed save, or half as much damage on a successful one.",
    "Each creature within 10 feet of the line but not in it must succeed on a Constitution saving throw or take 8d8 force damage and be pulled toward the line until the creature is in its area.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th level or higher, the damage increases by 1d8 for each slot level above 6th."
  ],
  "spellLists": ["wizard"]
}
